import React from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Objectives from "./ObjectivesComponent";
import Details from "./DetailsComponent";

export default function EventWImage(props) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col xs="12" sm="12" md="8" lg="8" xl="8" xxl="8" className="ps-1 ps-md-0 pe-2 pe-md-0">
            <Objectives
              objectives={props.objectives}
              talign="objective-align-justify"
            />
            <Details normalText={props.normalText} />
          </Col>
          <Col
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            xxl="4"
            className="d-flex flex-wrap align-items-center"
          >
            <Image
              className="photoArticol d-none d-md-block"
              src={props.photoSource}
              alt={props.alt}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
